import Hero from '../components/Hero'
import About from '../components/About'
import Projects from '../components/Projects'
import Contact from '../components/Contact'

const HomePage = () => {
    return (
      <div>
        <Hero />
        <About />
        <Projects />
        <Contact />
      </div>
    );
  }
  
  export default HomePage